var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.order
        ? [
            _vm.displayNotification(_vm.order, "revisingDateTime")
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "section-notification text-center" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "message.revise_datetime.cleaner_sent_revising_datetime_request"
                            )
                          ) +
                          "\n        "
                      ),
                      _c("svg", { staticClass: "notification-alert" }, [
                        _c("circle", { attrs: { cx: "3", cy: "3", r: "3" } })
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        [
          _vm.user &&
          _vm.order &&
          Number(_vm.user.id) === Number(_vm.order.user_id)
            ? [
                _c("div", { staticClass: "row py-4" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "text-primary-link",
                          attrs: { to: "/my-reservations" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("message.menu.my_reservations")) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "fal fa-angle-right" }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("message.my_reservations.reservation_detail")
                          ) +
                          "\n        "
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-4 d-flex h-100" }, [
                  _c("div", { staticClass: "col-7 align-self-center" }, [
                    _c("label", { staticClass: "m-0" }, [
                      _vm._v(
                        "\n            #" +
                          _vm._s(_vm.order.order_code) +
                          "\n            -\n            "
                      ),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$options.filters.serviceParentName(
                              _vm.order.service_id,
                              _vm.globalState.services
                            )
                          )
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-5 text-right" },
                    [
                      _vm.order.status < 2
                        ? [
                            _vm.order.payment_data.method === "credit_card" &&
                            _vm.order.subscription === null &&
                            _vm.order.package_id === null
                              ? [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-dark",
                                      on: { click: _vm.openCancelOrderModal }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.button.cancel_order"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-8" },
                    [
                      _c("received-order-section", {
                        attrs: { order: _vm.order }
                      }),
                      _vm._v(" "),
                      _c("review-section", { attrs: { order: _vm.order } }),
                      _vm._v(" "),
                      _c("confirm-order-payment-section", {
                        attrs: { order: _vm.order }
                      }),
                      _vm._v(" "),
                      _c("confirm-request-additional-hours-section", {
                        attrs: { order: _vm.order }
                      }),
                      _vm._v(" "),
                      !_vm.order.package_id && !_vm.order.subscription_id
                        ? _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start align-items-center"
                                },
                                [
                                  _c("div", { staticClass: "flex-fill" }, [
                                    _c("i", {
                                      staticClass: "fas fa-repeat text-info"
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.my_reservations.repeat_booking_label"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-info",
                                        on: {
                                          click: function($event) {
                                            return _vm.repeatBooking(_vm.order)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.button.repeat_booking"
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.order.status === 2 &&
                      _vm.order.order_photos &&
                      _vm.order.sent_photo_status === 1
                        ? _c("section", [
                            _c("div", { staticClass: "card panel-white" }, [
                              _c(
                                "div",
                                { staticClass: "card-body" },
                                [
                                  _c("div", { staticClass: "mb-2" }, [
                                    _c("label", [
                                      _c("i", { staticClass: "fal fa-images" }),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.my_reservations.completed_cleaning_photos"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("photos-album", {
                                    attrs: {
                                      photos: _vm.order.order_photos,
                                      photoType: "order_photos",
                                      includeGallery: true
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("my-cleaner", {
                        staticClass: "text-center d-block d-lg-none",
                        attrs: { order: _vm.order, imgSize: 56 }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card panel-white" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.my_reservations.status")
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$options.filters.orderStatus(_vm.order)
                                  )
                                }
                              })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.order.subscription_id
                          ? _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3 mb-2" }, [
                                  _c("span", { staticClass: "text-orange" }, [
                                    _c("i", {
                                      staticClass: "fal fa-calendar-alt"
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("message.subscription.title")
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-9" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("message.subscription.title")
                                      ) +
                                      " #" +
                                      _vm._s(_vm.order.subscription_id) +
                                      "\n                  - " +
                                      _vm._s(
                                        _vm._f("multiLangName")(
                                          _vm.order.subscription
                                            .subscription_type
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                  _c("div", { staticClass: "mt-2" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.subscription.next_subscription"
                                          )
                                        ) +
                                        ":\n                    "
                                    ),
                                    _vm.order.subscription.subscription_group
                                      .cancel === 0
                                      ? _c(
                                          "span",
                                          { staticClass: "text-info" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm._f("prettyOnlyDate")(
                                                    _vm.order.subscription
                                                      .recurring_date
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.button.cancel"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mt-2" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-block pointer-item",
                                        on: {
                                          click: _vm.openSubscriptionOrdersModal
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.subscription.view_all_bookings"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.order.paid_status === 1 &&
                                  _vm.order.subscription.subscription_group
                                    .cancel === 0
                                    ? _c("div", { staticClass: "mt-2" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-block btn-outline-info",
                                            on: { click: _vm.unsubscribe }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.subscription.unsubscribe"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order.package_id
                          ? _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3 mb-2" }, [
                                  _c("span", { staticClass: "text-orange" }, [
                                    _c("i", {
                                      staticClass: "fal fa-layer-group"
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.my_reservations.package"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-9" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.my_reservations.package"
                                        )
                                      ) +
                                      " #" +
                                      _vm._s(_vm.order.package_id) +
                                      "\n                  - " +
                                      _vm._s(
                                        _vm._f("multiLangName")(
                                          _vm.order.package.package_type
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                  _vm.order.package.package_type.category ===
                                  "unlimited"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.new_booking.package_count",
                                                {
                                                  count:
                                                    _vm.order.package.orders
                                                      .length
                                                }
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.order.package.package_type
                                    .is_hidden_info === 0
                                    ? _c("div", { staticClass: "mt-3" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary btn-block pointer-item",
                                            on: {
                                              click:
                                                _vm.openSubscriptionOrdersModal
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.subscription.view_all_bookings"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order.host
                          ? _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("span", { staticClass: "text-orange" }, [
                                    _c("i", { staticClass: "fal fa-bed" }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.my_reservations.for_host"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.my_reservations.contract_number"
                                          )
                                        ) +
                                        "\n                    " +
                                        _vm._s(_vm.order.host.contract_number) +
                                        "\n                  "
                                    )
                                  ])
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.my_reservations.cleaning_date"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-9" },
                              [
                                _c("div", { staticClass: "d-flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex-fill" },
                                    [
                                      _vm.order.revise_datetime_data &&
                                      _vm.order.status === 1
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "strike text-secondary"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm._f("prettyDate")(
                                                        _vm.order.cleaning_date
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "text-info" },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm._f("prettyDate")(
                                                        _vm.order
                                                          .revise_datetime_data
                                                          .cleaning_date
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.order.revise_datetime_data
                                              .sender_type === "user"
                                              ? [
                                                  _c(
                                                    "div",
                                                    { staticClass: "py-3" },
                                                    [
                                                      _vm._m(0),
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.my_reservations.you_want_to_change_date_time"
                                                            )
                                                          ) +
                                                          "\n                          "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-outline-info btn-block",
                                                      attrs: {
                                                        disabled:
                                                          _vm.state
                                                            .isCancelingReviseDateTime
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.cancelReviseDateTime
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              _vm.isCancelingReviseDateTime
                                                            )
                                                          ) +
                                                          "\n                          "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    { staticClass: "py-3" },
                                                    [
                                                      _vm._m(1),
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.my_reservations.cleaner_want_to_change_date_time"
                                                            )
                                                          ) +
                                                          "\n                          "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !_vm.state
                                                    .isConfirmingReviseDateTime
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "d-flex"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex-fill pr-1"
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-info btn-block",
                                                                  on: {
                                                                    click:
                                                                      _vm.acceptReviseDateTime
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.revise_datetime.accept"
                                                                        )
                                                                      ) +
                                                                      "\n                              "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex-fill pl-1"
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-outline-secondary btn-block",
                                                                  on: {
                                                                    click:
                                                                      _vm.declineReviseDateTime
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.revise_datetime.decline"
                                                                        )
                                                                      ) +
                                                                      "\n                              "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/img/ring.gif",
                                                            width: "40"
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.processing"
                                                              )
                                                            ) +
                                                            "\n                          "
                                                        )
                                                      ]
                                                ]
                                          ]
                                        : _c(
                                            "span",
                                            [
                                              _vm.order.revise_datetime_data
                                                ? [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm._f("prettyDate")(
                                                            _vm.order
                                                              .revise_datetime_data
                                                              .cleaning_date
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                : [
                                                    _vm.order.cleaning_date
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "prettyDate"
                                                              )(
                                                                _vm.order
                                                                  .cleaning_date
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.my_reservations.booking_date_not_specified"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                  ]
                                            ],
                                            2
                                          )
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.isAbleReviseDateTime(_vm.order)
                                  ? _c("div", { staticClass: "pt-3" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info btn-block",
                                          on: {
                                            click: _vm.openReviseDateTimeModal
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.my_reservations.change_date_time"
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("select-service-date-time-section", {
                                  staticClass: "mt-2",
                                  attrs: { order: _vm.order }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-md-3" }, [
                              _vm.parentServiceId === 1
                                ? _c("label", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.my_reservations.duration"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                : _vm.globalState.services[
                                    _vm.parentServiceId
                                  ] &&
                                  _vm.globalState.services[_vm.parentServiceId]
                                    .child_services_text
                                ? _c("label", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.booking.booking_step.service"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                : _vm.globalState.services[
                                    _vm.parentServiceId
                                  ] &&
                                  _vm.globalState.services[_vm.parentServiceId]
                                    .has_service_items
                                ? _c("label", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.service_item.list_of_items"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-9" },
                              [
                                _c("div", { staticClass: "d-flex" }, [
                                  _c("div", { staticClass: "flex-fill" }, [
                                    _vm.parentServiceId === 1
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(_vm.order.work_hour) +
                                              "\n                        " +
                                              _vm._s(
                                                _vm.$tc(
                                                  "message.hour",
                                                  _vm.order.work_hour
                                                )
                                              ) +
                                              "\n                      "
                                          )
                                        ])
                                      : _vm.globalState.services[
                                          _vm.parentServiceId
                                        ] &&
                                        _vm.globalState.services[
                                          _vm.parentServiceId
                                        ].child_services_text
                                      ? _c("div", [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$options.filters.serviceParentName(
                                                  _vm.order.service_id,
                                                  _vm.globalState.services
                                                )
                                              )
                                            }
                                          }),
                                          _vm._v(
                                            " • \n                        " +
                                              _vm._s(
                                                _vm._f("multiLangName")(
                                                  _vm.globalState.services[
                                                    _vm.order.service_id
                                                  ]
                                                )
                                              ) +
                                              "\n                        "
                                          ),
                                          _vm._v(" "),
                                          _vm.order.purchases.length > 0
                                            ? _c(
                                                "div",
                                                { staticClass: "pt-2" },
                                                [
                                                  _vm._m(2),
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.my_reservations.has_order_purchase"
                                                        )
                                                      ) +
                                                      " X" +
                                                      _vm._s(
                                                        _vm.order.purchases
                                                          .length
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm.globalState.services[
                                          _vm.parentServiceId
                                        ] &&
                                        _vm.globalState.services[
                                          _vm.parentServiceId
                                        ].has_service_items
                                      ? _c(
                                          "div",
                                          [
                                            _vm._l(
                                              _vm.order.order_service_items,
                                              function(orderServiceItem) {
                                                return _c(
                                                  "div",
                                                  { staticClass: "mb-1" },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "multiLangName"
                                                          )(
                                                            orderServiceItem.service_item
                                                          )
                                                        ) +
                                                        ": " +
                                                        _vm._s(
                                                          orderServiceItem.quantity
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "multiLangName"
                                                          )(
                                                            orderServiceItem
                                                              .service_item
                                                              .item_unit
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-info text-small mt-2"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.service_item.remark"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.canBookAdditionalHours(_vm.order)
                                  ? _c(
                                      "div",
                                      { staticClass: "pt-3" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "btn btn-info btn-block",
                                            attrs: {
                                              to:
                                                "/reservation/" +
                                                _vm.order.id +
                                                "/additional-hours"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.my_reservations.additional_hours"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.order.professional_id &&
                                _vm.parentServiceId === 2
                                  ? _c(
                                      "div",
                                      { staticClass: "pt-3" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "btn btn-info btn-block",
                                            attrs: {
                                              to:
                                                "/reservation/" +
                                                _vm.order.id +
                                                "/purchase-service"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.my_reservations.book_additional_ironing_service"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("order-additional-hours", {
                                  attrs: { order: _vm.order }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.order.extra
                          ? _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3 col-12" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.my_reservations.extras")
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-9 col-12" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("multiLangName")(_vm.order.extra)
                                      ) +
                                      "\n                  "
                                  ),
                                  _vm.order.purchases.length > 0
                                    ? _c("div", { staticClass: "pt-2" }, [
                                        _vm._m(3),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.my_reservations.has_order_purchase"
                                              )
                                            ) +
                                            " X" +
                                            _vm._s(_vm.order.purchases.length) +
                                            "\n                  "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.order.professional_id &&
                                  _vm.order.extra.service_id === 2
                                    ? _c(
                                        "div",
                                        { staticClass: "pt-3" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn btn-info btn-block",
                                              attrs: {
                                                to:
                                                  "/reservation/" +
                                                  _vm.order.id +
                                                  "/purchase-service"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.my_reservations.book_additional_ironing_service"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.my_reservations.customer_name"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-9" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.order.customer_name) +
                                  "\n                "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.my_reservations.customer_address"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-9" }, [
                              _vm.order.place_name
                                ? _c("p", [
                                    _vm._v(_vm._s(_vm.order.place_name))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("multiLangName")(
                                        _vm.$t(
                                          _vm.globalState.placeSizes[
                                            _vm.order.place_size_id
                                          ]
                                        )
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(_vm.order.address))])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.order.user_place &&
                          _vm.order.user_place.has_pet === 1
                            ? _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("message.my_reservations.pet")
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-9" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.order.user_place.pet_remark) +
                                      "\n                "
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.order.remark
                          ? _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.my_reservations.remark")
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-md-9",
                                    staticStyle: {
                                      "white-space": "break-spaces"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.order.remark))]
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order.customer_area_photos
                          ? _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c("div", { staticClass: "mb-2" }, [
                                  _c("label", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.booking.checkout_step.customer_area_photos"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("photos-album", {
                                  attrs: {
                                    photos: _vm.order.customer_area_photos,
                                    photoType: "customer_area_photos",
                                    includeGallery: true
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order.service_id === 1 &&
                        _vm.order.user_place &&
                        _vm.order.user_place.checklist
                          ? _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.my_reservations.checklist"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-9" },
                                  [
                                    _vm._l(
                                      _vm.order.user_place.checklist,
                                      function(checklist) {
                                        return [
                                          _c("div", { staticClass: "mb-2" }, [
                                            _c("i", {
                                              staticClass: "fa fa-check"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(checklist) +
                                                "\n                    "
                                            )
                                          ])
                                        ]
                                      }
                                    )
                                  ],
                                  2
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.my_reservations.payment")
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-9" },
                              [
                                _vm.order
                                  ? _c("order-summary-total", {
                                      attrs: { order: _vm.order }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.order.professional_tip &&
                        _vm.order.professional_tip.paid_status
                          ? _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3 col-3" }, [
                                  _c("label", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.professional_tip.amount"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-9 col-9 text-right" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            Number(
                                              _vm.order.professional_tip.amount
                                            )
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order.purchases.length > 0
                          ? _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.my_reservations.other_payments"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-9" },
                                  [
                                    _c("order-purchase", {
                                      attrs: { order: _vm.order }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-4 text-center" },
                    [
                      _c("my-cleaner", {
                        staticClass: "d-none d-lg-block",
                        attrs: { order: _vm.order, imgSize: 48 }
                      })
                    ],
                    1
                  )
                ])
              ]
            : [
                !_vm.user
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-lg-6 offset-lg-3 text-center" },
                        [
                          _c("div", { staticClass: "card my-3" }, [
                            _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c("div", { staticClass: "mt-3 mb-4" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.my_reservations.login_to_view_detail"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("login")
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm.user &&
                    _vm.order &&
                    Number(_vm.user.id) !== Number(_vm.order.user_id)
                  ? _c("div", { staticClass: "p-4" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col text-center" }, [
                          _c("h3", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "message.my_reservations.cannot_view_other_user_reservation"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        ])
                      ])
                    ])
                  : _c("div", [_c("loader")], 1)
              ],
          _vm._v(" "),
          _c("revise-date-time-modal", { ref: "reviseDateTimeModal" }),
          _vm._v(" "),
          _c("subscription-orders-modal", { ref: "subscriptionOrdersModal" }),
          _vm._v(" "),
          _vm.user
            ? _c("cancel-order-modal", {
                ref: "cancelOrderModal",
                attrs: { orderId: _vm.orderId, userId: _vm.user.id },
                on: { cancelledOrder: _vm.cancelledOrder }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("purchase-service-modal", {
            ref: "purchaseServiceModal",
            attrs: { parentServiceId: 2 }
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cbbfe04", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cbbfe04","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/OrderDetail.vue
// module id = 1660
// module chunks = 0